import { render, staticRenderFns } from "./LoadedCarData.vue?vue&type=template&id=226cca37&scoped=true&"
import script from "./LoadedCarData.vue?vue&type=script&lang=js&"
export * from "./LoadedCarData.vue?vue&type=script&lang=js&"
import style0 from "./LoadedCarData.vue?vue&type=style&index=0&id=226cca37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226cca37",
  null
  
)

export default component.exports